import styled, {ThemeProps} from 'styled-components';
import {FlexCentered} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

// TYPES
import {Assign} from 'utility-types';
import {Theme} from '../../../../../../stories/theme/types';

export const PersuasionContainer = styled(FlexCentered)(
  props => `
  padding-top:${props.theme.spacing.large};
`,
);

export const PersuasionText = styled.span(
  props => `

  font-size:${props.theme.font.custom(14)};
  color: ${props.theme.colors.downriver.dark};
  padding-left:${props.theme.spacing.base};
  background: ${props.background ? props.background : props.theme.colors.goWhite.base};
`,
);

export const RatingContainer = styled(FlexCentered)(
  props => `
  flex-direction: column;
  padding:${props.theme.spacing.small} 0;
  background-color: ${props.bgColor};
  border-radius: ${props.theme.misc.borderRadius.large};
  color: ${props.theme.colors.goWhite.base};
  width:9rem;
  margin-left:auto;
`,
);

export const ReviewNumber = styled.span(
  (props: Assign<ThemeProps<Theme>, {color?: string}>) => `
  font-size:${props.theme.font.custom(20)};
  font-weight: bold;
`,
);

export const OutOfNumberForReview = styled.span(
  props => `
  font-size:${props.theme.font.custom(14)};
  font-weight: bold;
  padding-top:0.7rem;
`,
);

export const TripadvisorImg = styled(Image)(
  props => `
  width: 28px;
  margin: 0 3px;
`,
);

export const NumberOfRatingsStyled = styled.span(
  props => `
  font-size:${props.theme.font.small};
  color: ${props.theme.colors.goWhite.base};
  padding-top:${props.theme.spacing.small};
`,
);
